module.exports = __webpack_public_path__ + "static/media/foryou1.32182956.jpg";